var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { MdNavigateBefore } from 'react-icons/md';
import * as SharedStyle from '../../shared-style';

var CatalogTurnBackPageItem = function (_Component) {
  _inherits(CatalogTurnBackPageItem, _Component);

  function CatalogTurnBackPageItem(props) {
    _classCallCheck(this, CatalogTurnBackPageItem);

    var _this = _possibleConstructorReturn(this, (CatalogTurnBackPageItem.__proto__ || Object.getPrototypeOf(CatalogTurnBackPageItem)).call(this, props));

    _this.state = { hover: false };
    return _this;
  }

  _createClass(CatalogTurnBackPageItem, [{
    key: 'changePage',
    value: function changePage(newPage) {
      this.context.projectActions.goBackToCatalogPage(newPage);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var page = this.props.page;
      var hover = this.state.hover;

      return React.createElement(
        'div',
        {
          className: this.props.isSidebar ? "turn-back-box-sidebar" : "turn-back-box",
          onClick: function onClick(e) {
            return _this2.changePage(page.name);
          },
          onMouseEnter: function onMouseEnter(e) {
            return _this2.setState({ hover: true });
          },
          onMouseLeave: function onMouseLeave(e) {
            return _this2.setState({ hover: false });
          }
        },
        React.createElement(
          'div',
          { className: this.props.isSidebar ? "turn-back-container-sidebar" : "turn-back-container" },
          React.createElement(MdNavigateBefore, { className: this.props.isSidebar ? "turn-back-sidebar" : "turn-back" })
        )
      );
    }
  }]);

  return CatalogTurnBackPageItem;
}(Component);

export default CatalogTurnBackPageItem;


CatalogTurnBackPageItem.propTypes = {
  page: PropTypes.object.isRequired,
  isSidebar: PropTypes.bool
};

CatalogTurnBackPageItem.contextTypes = {
  projectActions: PropTypes.object.isRequired
};